<template>
    <div class="row">
      <div class="col-md-6 col-lg-7 col-xl-8">
        <card class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Βασικά Στοιχεία</h4>
            <div class="form-group">
              <label class="control-label" for="firstname_input">Όνομα</label>
              <input class="form-control" id="firstname_input" type="text" v-model.trim="user.firstName" required>
            </div>
            <div class="form-group">
              <label class="control-label" for="lastname_input">Επώνυμο</label>
              <input class="form-control" id="lastname_input" type="text" v-model.trim="user.lastName" required>
            </div>
          </div>
          <div class="card-footer">
            <div class="text-center">
              <button class="btn btn-success" @click="saveBasicInfo" :disabled="savingBasicInfo">Αποθηκευση<span v-if="savingBasicInfo">...</span></button>
              <div v-if="basicInfoErrorMsg !== ''" class="text-danger mt-1">{{ basicInfoErrorMsg }}</div>
            </div>
          </div>
        </card>
      </div>
      <div class="col-md-6 col-lg-5 col-xl-4">
        <card class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Στοιχεία Σύνδεσης</h4>
            <div class="form-group">
              <label class="control-label" for="email_input">Email</label>
              <input class="form-control" id="email_input" type="email" :value="user.email" required disabled>
              <div class="text-center mt-2"><a href="javascript:void(0);" @click="resetEmail.show=!resetEmail.show;">αλλαγή email</a></div>
              <div v-show="resetEmail.show">
                <label class="control-label" for="new_email_input">Νέο Email</label>
                <input class="form-control" id="new_email_input" type="email" v-model="resetEmail.email" required>
                <label class="control-label mt-2" for="new_email2_input">Επαλήθευση νέου Email</label>
                <input class="form-control" id="new_email2_input" type="email" v-model="resetEmail.email2" required>
                <div class="text-center">
                  <button class="btn btn-success mt-2" @click="sendResetEmail">Αποθηκευση<span v-if="sendingResetEmail">...</span></button>
                  <div v-if="resetEmail.errorMsg !== ''" class="text-danger mt-1">{{ resetEmail.errorMsg }}</div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="control-label" for="password_input">Κωδικός</label>
              <input class="form-control" id="password_input" type="password" :value="'*****'" required disabled>
              <div class="text-center mt-2"><a href="javascript:void(0);" @click="resetPassword">αλλαγή κωδικού</a></div>
            </div>
          </div>
        </card>
      </div>
    </div>
</template>
<script>
import Api from "../api";
export default {
  components: {
    
  },
  data() {
    return {
      basicInfoErrorMsg: "",
      savingBasicInfo: false,
      user: {
        firstName: "",
        lastName: "",
        email: "",
        hasVerifiedEmail: ""
      },
      resetEmail: {
        show: false,
        errorMsg: "",
        email: "",
        email2: ""
      },
      sendingResetEmail: false
    };
  },
  mounted() {
    this.getBasicInfo ();
  },
  methods: {
    getBasicInfo () {
      Api.send("GET", "/user/basic_info", {})
        .then((response) => {
          this.user.email = response.data.email;
          this.user.firstName = response.data.firstName;
          this.user.lastName = response.data.lastName;
        })
        .catch((err) => {
          this.$root.notifyy('danger', err.msg);
        })
        .finally(() => {
          
        });
    },
    saveBasicInfo () {
      this.basicInfoErrorMsg = "";
      if (this.user.firstName === "" || this.user.lastName === "") {
        this.basicInfoErrorMsg = "Όλα τα πεδία είναι υποχρεωτικά";
        return false;
      }

      this.savingBasicInfo = true;
      Api.send("PUT", "/user/update", {firstName: this.user.firstName, lastName: this.user.lastName})
      .then((response) => {
        this.basicInfoErrorMsg = "";
        this.$root.notifyy('success', response.msg);
        let loggedUser = this.$root.getLoggedUser();
        loggedUser.firstName = this.user.firstName;
        loggedUser.lastName = this.user.lastName;
        this.$root.setLoggedUser(loggedUser);
      })
      .catch((err) => {
        this.basicInfoErrorMsg = err.msg;
      })
      .finally(() => {
        this.savingBasicInfo = false;
      });
    },
    sendResetEmail () {
      if (this.sendingResetEmail) {
        return false;
      }
      this.resetEmail.errorMsg = "";
      if (this.resetEmail.email === "" || this.resetEmail.email2 === "") {
        this.resetEmail.errorMsg = "Όλα τα πεδία είναι υποχρεωτικά";
        return false;
      }
      if (this.resetEmail.email2 !== this.resetEmail.email) {
        this.resetEmail.errorMsg = "Το email επαλήθευσης δεν είναι το ίδιο";
        return false;
      }
      if (confirm('Για λόγους ασφαλείας πρόκειται να σας αποσυνδέσουμε και στη συνέχεια θα σας στείλουμε τον σύνδεσμο αλλαγής της ηλεκτρονικής σας διεύθυνσης στο νέο email. Θέλετε να προχωρήσετε;')) {
        this.sendingResetEmail = true;
        Api.send("POST", "/user/reset/email/send", {email: this.resetEmail.email})
          .then((response) => {
            this.resetEmail.errorMsg = "";
            this.$root.deleteLoggedUser();
            this.$router.push({path:'reset_email_send_success'});
          })
          .catch((err) => {
            this.resetEmail.errorMsg = err.msg;
          })
          .finally(() => {
            this.sendingResetEmail = false;
          });
      }
    },
    resetPassword () {
      if (confirm('Για λόγους ασφαλείας πρόκειται να σας αποσυνδέσουμε και στη συνέχεια θα σας μεταφέρουμε στη σελίδα επαναφοράς κωδικού. Θέλετε να προχωρήσετε;')) {
        this.$root.deleteLoggedUser();
        this.$router.push({path:'reset_password'});
      }
    }
  },
};
</script>
<style>
</style>
